jQuery.fn.setAllToMaxHeight = function(){
    return this.height( Math.max.apply(this, jQuery.map( this , function(e){ return jQuery(e).height() }) ) );
}


$(window).load(function() {
    $('ul.product-collection li a').setAllToMaxHeight();
	$('#featured').orbit({
		bullets: false,
		timer: true,
        advanceSpeed: 7000
	});

});


/* Foundation v2.2 http://foundation.zurb.com */
jQuery(document).ready(function ($) {

	/* Use this js doc for all application specific JS */

    $(".main-content").fitVids();  
  
    $('#menu-dropdown').val(window.location.pathname); 
    
    $('#menu-dropdown').on("change", function(e){
    	e.preventDefault();
        window.location = $(this).val();
	});	

    $('#cartform a.update-line').on("click", function(e){
        $('#cartform').submit();
	});	    
    
	$("#cartform .quantity").on("click", function(){
		$(this).select();
	});
	
    $("a.small-image").fancybox({
      'overlayColor':    "#000", 
      'overlayOpacity': "0.5"
    });
	
   $('#main-image').on('click', function(e) {
      e.preventDefault();
      var imageId = $(this).data('image-id');
      $('a.small-image[data-image-id="' + imageId + '"]').trigger("click");
	});    
   
   
	$('#back-top a').on("click", function(e){
		e.preventDefault();
		$('html, body').animate({scrollTop:0}, 500, 'swing');
	});
	
	
	/* TABS --------------------------------- */
	/* Remove if you don't need :) */

	function activateTab($tab) {
		var $activeTab = $tab.closest('dl').find('a.active'),
				contentLocation = $tab.attr("href") + 'Tab';

		//Make Tab Active
		$activeTab.removeClass('active');
		$tab.addClass('active');

    	//Show Tab Content
		$(contentLocation).closest('.tabs-content').children('li').hide();
		$(contentLocation).css('display', 'block');
	}

	$('dl.tabs').each(function () {
		//Get all tabs
		var tabs = $(this).children('dd').children('a');
		tabs.click(function (e) {
			activateTab($(this));
		});
	});

	if (window.location.hash) {
		activateTab($('a[href="' + window.location.hash + '"]'));
	}

	/* ALERT BOXES ------------ */
	$(".alert-box").delegate("a.close", "click", function(event) {
    event.preventDefault();
	  $(this).closest(".alert-box").fadeOut(function(event){
	    $(this).remove();
	  });
	});


	/* PLACEHOLDER FOR FORMS ------------- */
	/* Remove this and jquery.placeholder.min.js if you don't need :) */

	//$('input, textarea').placeholder();

    /* TOOLTIPS ------------ */
    // disable for touch screens
    //if (!Modernizr.touch){
	//    $(this).tooltips();
    //}

	/* UNCOMMENT THE LINE YOU WANT BELOW IF YOU WANT IE6/7/8 SUPPORT AND ARE USING .block-grids */
	//$('.block-grid.two-up>li:nth-child(2n+1)').css({clear: 'left'});
	//$('.block-grid.three-up>li:nth-child(3n+1)').css({clear: 'left'});
	//$('.block-grid.four-up>li:nth-child(4n+1)').css({clear: 'left'});
	//$('.block-grid.five-up>li:nth-child(5n+1)').css({clear: 'left'});



	/* DROPDOWN NAV ------------- */

	var lockNavBar = false;
	$('.nav-bar a.flyout-toggle').on('click', function(e) {
		e.preventDefault();
		var flyout = $(this).siblings('.flyout');
		if (lockNavBar === false) {
			$('.nav-bar .flyout').not(flyout).slideUp(500);
			flyout.slideToggle(500, function(){
				lockNavBar = false;
			});
		}
		lockNavBar = true;
	});

    if ($(window).width() > 767) {  
       // desktop menu 
       $('.nav-bar>li.has-flyout').hover(function() {
         $(this).children('.flyout').stop(true,true).fadeIn(300);
	     //$(this).children('.flyout').show();
	     $(this).addClass('menu-active');
       }, function() {
         //$(this).children('.flyout').stop(true,true).slideUp(200);
	     $(this).children('.flyout').hide();
	     $(this).removeClass('menu-active');
       });  
    }

  
    $('form.contact-form, form.comment-form, form#customer_login, form#create_customer, #recover-password form, form#address_form_new, .edit_address form').addClass('nice');
    $('form#address_form_new input[type=text], .edit_address form input[type=text]').addClass('input-text');
    
	/* DISABLED BUTTONS ------------- */
	/* Gives elements with a class of 'disabled' a return: false; */
    
    $('.gt-accordion h4').each(function() {
        var tis = $(this), state = false, answer = tis.next('div').slideUp();
        tis.click(function() {
            state = !state;
            answer.slideToggle(state);
            tis.toggleClass('active',state);
        });
    });   

});

  
/*!
* FitVids 1.0.3
*
* Copyright 2013, Chris Coyier - http://css-tricks.com + Dave Rupert - http://daverupert.com
* Credit to Thierry Koblentz - http://www.alistapart.com/articles/creating-intrinsic-ratios-for-video/
* Released under the WTFPL license - http://sam.zoy.org/wtfpl/
*
* Date: Thu Sept 01 18:00:00 2011 -0500
*/
(function(e){"use strict";e.fn.fitVids=function(t){var n={customSelector:null};if(!document.getElementById("fit-vids-style")){var r=document.createElement("div"),i=document.getElementsByTagName("base")[0]||document.getElementsByTagName("script")[0],s="&shy;<style>.fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}</style>";r.className="fit-vids-style";r.id="fit-vids-style";r.style.display="none";r.innerHTML=s;i.parentNode.insertBefore(r,i)}if(t){e.extend(n,t)}return this.each(function(){var t=["iframe[src*='player.vimeo.com']","iframe[src*='youtube.com']","iframe[src*='youtube-nocookie.com']","iframe[src*='kickstarter.com'][src*='video.html']","object","embed"];if(n.customSelector){t.push(n.customSelector)}var r=e(this).find(t.join(","));r=r.not("object object");r.each(function(){var t=e(this);if(this.tagName.toLowerCase()==="embed"&&t.parent("object").length||t.parent(".fluid-width-video-wrapper").length){return}var n=this.tagName.toLowerCase()==="object"||t.attr("height")&&!isNaN(parseInt(t.attr("height"),10))?parseInt(t.attr("height"),10):t.height(),r=!isNaN(parseInt(t.attr("width"),10))?parseInt(t.attr("width"),10):t.width(),i=n/r;if(!t.attr("id")){var s="fitvid"+Math.floor(Math.random()*999999);t.attr("id",s)}t.wrap('<div class="fluid-width-video-wrapper"></div>').parent(".fluid-width-video-wrapper").css("padding-top",i*100+"%");t.removeAttr("height").removeAttr("width")})})}})(window.jQuery||window.Zepto);

  